import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  Person,
  RocketLaunch,
  UploadFile,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";

import { MenuCard } from "@/components/molecules";
import { checkPermission } from "@/utils";
import { useNavigate } from "react-router-dom";

const HomePageMenu = () => {
  const { user } = useAuth0();
  const navigate = useNavigate();

  return (
    <>
      <Grid>
        <MenuCard
          title="Build an Audience"
          buttonText="New Audience"
          text={`
                  Create custom, self-serve audiences by combining attributes from multiple data sources to fit your 
                  campaign brief and target the geos to best reach them
                `}
          onClick={() => navigate("audience/new")}
          icon={<Person color="primary" />}
          disabled={user && checkPermission(user, "audiences")}
        />
      </Grid>
      <Grid>
        <MenuCard
          title="Upload Postcodes"
          buttonText="New Upload"
          text={`
                  Match your 1st party data to understand your customer segments or upload store/site locations to 
                  understand their local catchment
                `}
          onClick={() => navigate("upload/new")}
          icon={<UploadFile color="primary" />}
          disabled={user && checkPermission(user, "uploads")}
        />
      </Grid>
      <Grid>
        <MenuCard
          title="Activate Geos"
          buttonText="New Activation"
          text={`
                  Combine Connect Audiences into Custom campaigns that you can target directly within your favourite 
                  platforms  
                `}
          onClick={() => navigate("activation/new")}
          icon={<RocketLaunch color="primary" />}
          disabled={user && checkPermission(user, 'activations')}
        />
      </Grid>
    </>
  );
};

export default HomePageMenu;
